import React from 'react';

const UniqueSection = () => {
    return (
        <section className="unique-section" style={{backgroundColor:''}}>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-4 d-flex flex-column align-items-center">
                        <div className="info-item py-5">
                            <strong className="info-title">
                                <i className="fas fa-car px-2 darkcolor"></i>
                                Personalized Travel Solutions
                            </strong>
                            <p className="info-description">
                                At AB Ghule Cabs, we offer tailor-made travel services to meet your specific needs, whether it's a city ride or an outstation trip.
                            </p>
                        </div>
                        <div className="info-item">
                            <strong className="info-title">
                                <i className="fas fa-headset px-2 darkcolor"></i>
                                24/7 Customer Support
                            </strong>
                            <p className="info-description">
                                Our dedicated customer support team is available 24/7 to ensure your journey is hassle-free and enjoyable at every step.
                            </p>
                        </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex justify-content-center">
                        <img 
                            // src="/images/about/dezire.jpg" 
                            src="images/innova.png" 
                            alt="Reliable and Comfortable Cabs" 
                            className="experience-image img-fluid" 
                        />
                    </div>

                    <div className="col-12 col-md-4 d-flex flex-column align-items-center">
                        <div className="info-item py-5">
                            <strong className="info-title">
                                <i className="fas fa-thumbs-up px-2 darkcolor"></i>
                                Affordable & Reliable Service
                            </strong>
                            <p className="info-description">
                                Experience comfort and reliability without compromising your budget, with AB Ghule Cabs' competitive pricing.
                            </p>
                        </div>
                        <div className="info-item">
                            <strong className="info-title">
                                <i className="fas fa-calendar-check px-2 darkcolor"></i>
                                Timely & Efficient Journeys
                            </strong>
                            <p className="info-description">
                                Our punctuality and efficient routes ensure you reach your destination on time, every time.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UniqueSection;
